import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.config.productionTip = false

export const app = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
